import { render, staticRenderFns } from "./Devize_finalizate_list.vue?vue&type=template&id=94b4f254&scoped=true"
import script from "./Devize_finalizate_list.vue?vue&type=script&lang=js"
export * from "./Devize_finalizate_list.vue?vue&type=script&lang=js"
import style0 from "./Devize_finalizate_list.vue?vue&type=style&index=0&id=94b4f254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b4f254",
  null
  
)

export default component.exports